<template>
  
  <div :id="`loadableContent-comments-${post.id}`" class="post comments" :class="page.network" v-if="post">
    <div class="content" v-if="badWordsFeed">
      <ul>
        <li :class="`comment-bad-word`">
          <comment 
            :comment="post.comment" 
            :page="page"
            :badWordsFeed="badWordsFeed"
            :badWordList="badWordList"
            v-on:hide="hideComment"
            v-on:delete="deleteComment"
            v-on:block="blockUser"
            v-on:getComments="getComments"
            v-on:likeComment="likeNodeAction"
            v-on:badWordsDetected="badWordsDetected"
          ></comment>
        </li>
      </ul>
    </div>
    <div class="content" v-else-if="comments">
      <div class="activatecomments" v-if="page.network == 'instagram'">
        <vs-dropdown :vs-trigger-click="true">
          <vs-button class="text-align: right"><img src="../../assets/img/icon_tree_dot.svg"></vs-button>
          <vs-dropdown-menu>
           <vs-dropdown-item v-if="post.is_comment_enabled == false && page.network == 'instagram'" @click.prevent="switchComment(post.id, post.is_comment_enabled)">
              {{$t('dash.button.activate.comment')}}
            </vs-dropdown-item>
             <vs-dropdown-item v-if="post.is_comment_enabled == true && page.network == 'instagram'" @click.prevent="switchComment(post.id, post.is_comment_enabled)">
              {{$t('dash.button.desactivate.comment')}}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="comments-desactivate" v-if="page.network == 'instagram' && post.is_comment_enabled == false">
              {{$t('dash.preview.comment.desactivate')}}
      </div>
      <div class="stats">
        <div class="likes-count" :class="[{'already': has_liked}]" @click="!has_liked ? likeNodeAction(post, true) : ''">{{ getCountLikes }} {{$t('dash.label.fb.like')}}</div>
        <div class="shares-count" v-if="page.network != 'linkedin' && page.network != 'instagram'">{{ getCountShares }} {{$t('dash.label.fb.shares')}}</div>
        <div class="comments-count">{{ getCountComments }} {{$t('dash.label.fb.comments')}}</div>
      </div>
      <div class="message">
        <message-comment 
          :node="post" 
          :page="page"
          v-on:getComments="getComments"
          v-on:likeComment="likeNodeAction"
        ></message-comment>
      </div>    
      <div class="pagination-comments previous-comments" v-if="comments.paging && comments.paging.previous">
        <vs-button class="page-btn btn-large" @click="paginationComments('previous')" vs-type="filled">
          {{ $t("dash.moderation.previous-comments")}}
        </vs-button>
      </div>
      <ul>
        <li v-for="(item, key) in comments.data" :key="key" :class="`comment-${key}`">
          <comment 
            :comment="item" 
            :page="page"
            :badWordList="badWordList"
            v-on:hide="hideComment"
            v-on:delete="deleteComment"
            v-on:block="blockUser"
            v-on:getComments="getComments"
            v-on:likeComment="likeNodeAction"
            v-on:badWordsDetected="badWordsDetected"
          ></comment>
        </li>
      </ul>
      <div class="pagination-comments next-comments" v-if="comments.paging && comments.paging.next">
        <vs-button class="page-btn btn-large" @click="paginationComments('next')" vs-type="filled">
          {{ $t("dash.moderation.next-comments")}}
        </vs-button>
      </div>
    </div>
    <div class="content" v-else>
      <div class="comments-desactivate" v-if="page.network == 'instagram' && post.is_comment_enabled == false">
              {{$t('dash.preview.comment.desactivate')}}
          </div>
      <div class="stats">
        <div class="likes-count" :class="[{'already': has_liked}]" @click="!has_liked ? likeNodeAction(post, true) : ''">{{ getCountLikes }} {{$t('dash.label.fb.like')}}</div>
        <div class="shares-count" v-if="page.network != 'linkedin' && page.network != 'instagram'">{{ getCountShares }} {{$t('dash.label.fb.shares')}}</div>
        <div class="comments-count">0 {{$t('dash.label.fb.comments')}}</div>
      </div>
      <div class="message">
        <message-comment 
          :node="post" 
          :page="page"
          v-on:getComments="getComments"
          v-on:likeComment="likeNodeAction"
        ></message-comment>
      </div> 
    </div>
  </div>
    
</template>

<script>
import Moderation from './../mixins/Moderation'
import Notif from './../mixins/Notif'
import Comment from './Comment.vue'
import MessageComment from './MessageComment'

export default {
  name: 'comments-post',

  mixins: [Moderation, Notif],
   

  components: {
    Comment,
    MessageComment,
  },

  props: {
    page: Object,
    post: Object,
    badWordsFeed: Boolean,
    badWordList: Array
  },

  data() {
    return {
      comments: null,
    }
  },

  async mounted(){
    if(this.post && this.post.comments && this.post.comments.data && this.post.comments.data.length > 0 || this.page.network == 'linkedin' && this.post.comment_count != 0) {
      this.getComments()
    }
    else {
      this.comments = []
    }
  },

  methods: {
     async switchComment(postid, postis_comment_enable){
      console.log('dans commentpost switchComment postid postcommentenable:', postid, postis_comment_enable)
     // await this.switchComments(this.pagesActive[this.selectedTab], postid, postis_comment_enable)
      this.$emit('switchComment', postid,postis_comment_enable)
      console.log('apres')
    },

    async getComments(){
      
      //this.comments = await this.getCommentsPost(this.page, this.post.id)

      this.$vs.loading({
        //background: 'primary',
        color: 'primary',
        container: `#loadableContent-comments-${this.post.id}`
      })

      console.log('l id du post :', this.post.id )
      var sendforcomments = this.post.id
      if(this.page.network == 'linkedin'){
        sendforcomments = this.post.activity
      }

      this.getCommentsPost(this.page, sendforcomments).then(res => {
        this.$vs.loading.close(`#loadableContent-comments-${this.post.id} > .con-vs-loading`)
        const { success, error } = res.body

        if (!success || success !== true) {
          return
          // this.$vs.notify({
          //   time: 10000,
          //   title: this.$t('dash.posts.error.title'),
          //   text: this.$t(error),
          //   color: 'primary'
          // })
        }

        this.comments = res.body.comments

        if(this.getCountComments) this.$emit('addCountComments', this.getCountComments)

      })
      
    },

    badWordsDetected(comment, badWords){
      this.$emit('badWordsDetected', this.post, comment, badWords)
    },

    paginationComments(type='next') {
      if(this.page.network == 'facebook'){
      let link = type == 'next' 
                  ? this.comments.paging.next
                  : this.comments.paging.previous

      this.$vs.loading({
        //background: 'primary',
        color: 'primary',
        container: `#loadableContent-comments-${this.post.id}`
      })

      this.getPreviousNextNodePageFromRS(link).then(res => {
        this.$vs.loading.close(`#loadableContent-comments-${this.post.id} > .con-vs-loading`)
        console.log('resmore : ', res)
        
        this.comments = res.body

        let top = document.querySelector(`#loadableContent-comments-${this.post.id}`).offsetTop
        scrollTo({ top: top, left: 0, behavior: 'smooth' })
      })
      }
      if(this.page.network == 'instagram'){
      let link = type == 'next' 
                  ? this.comments.paging.next
                  : this.comments.paging.previous

      this.$vs.loading({
        //background: 'primary',
        color: 'primary',
        container: `#loadableContent-comments-${this.post.id}`
      })

      this.getPreviousNextNodePageFromRS(link).then(res => {
        this.$vs.loading.close(`#loadableContent-comments-${this.post.id} > .con-vs-loading`)
         for(var i = 0; i<res.body.data.length; i++){
                  res.body.data[i].created_time = res.body.data[i].timestamp
                  res.body.data[i].message = res.body.data[i].text
                  res.body.data[i].is_hidden = res.body.data[i].hidden
                  res.body.data[i].from = {name: res.body.data[i].username}

                  if(res.body.data[i].replies)
                  res.body.data[i].comment_count = res.body.data[i].replies.data.length

                  //console.log('nombre de replies =', comments.data[i].replies.data.length)

                  
                  
                  //comments.data[i].from = comments.data[i].username
                  //comments.data[i].comment_count = comments.data[i].comments_count
                  //if(posts.data[i].thumbnail_url){
                  //  posts.data[i].full_picture = posts.data[i].thumbnail_url
                 // }

                  if(res.body.data[i].replies){
                    console.log('entrédansleif')
                    for(var j = 0; j<res.body.data[i].replies.data.length; j ++){
                      console.log('entré dans le for', j)
                      res.body.data[i].replies.data[j].created_time = res.body.data[i].replies.data[j].timestamp
                      res.body.data[i].replies.data[j].message = res.body.data[i].replies.data[j].text
                      res.body.data[i].replies.data[j].is_hidden = res.body.data[i].replies.data[j].hidden
                      res.body.data[i].replies.data[j].from = {name: res.body.data[i].replies.data[j].username}
                    }
                    res.body.data[i].comments = res.body.data[i].replies
                  }
                }
       // console.log('resmore : ', res)        
       // this.comments = res.body
      //  console.log('comments maj : ', this.comments)

        this.$set(this.comments, 'data', this.comments.data.concat(res.body.data))
        this.$set(this.comments, 'paging', res.body.paging ? res.body.paging : null)

       // let top = document.querySelector(`#loadableContent-comments-${this.post.id}`).offsetTop
       // scrollTo({ top: top, left: 0, behavior: 'smooth' })
      })
      }
    },

    async deleteComment(commentid, isBadWordsFeed=false){
      console.log('delete id commentpost', commentid)
      if(this.page.network == 'linkedin'){
          let status = await this.deleteNodelinkedin(this.page, this.post.activity, commentid)
      }
      else{
          let status = await this.deleteNode(this.page, commentid)
      }
      if(isBadWordsFeed)
        this.$emit('deleteCommentWithBadWord', commentid)
      else
        this.getComments()
    },

    async blockUser(commentfromid){
      console.log('entrer dans hidecomment, comment user ID:', commentfromid)
      let status = await this.blockUserComment(this.page, commentfromid)
      this.getComments()
    },

    async hideComment(commentid, is_hidden){
      console.log('entrer dans hidecomment commentspost')
      let status = await this.hideNode(this.page, commentid, is_hidden)
      this.getComments()
    },

    likeNodeAction(node, postNode=false){
      if(node.likes && node.likes.summary && node.likes.summary.has_liked)
        return

      this.$vs.loading({
        //background: 'primary',
        color: 'primary',
        container: `#loadableContent-comments-${this.post.id}`
      })

      this.likeNode(this.page, 
                    this.page.network == 'linkedin' ? (postNode ? this.post.activity : node['$URN'] || node.id) : node.id, 
                    this.page.network == 'linkedin' ? this.post.activity : null).then(res => {
        this.$vs.loading.close(`#loadableContent-comments-${this.post.id} > .con-vs-loading`)
        const { success, error } = res.body

        if (!success || success !== true) {
          // this.$vs.notify({
          this.notify({
            time: 10000,
            title: this.$t('dash.posts.error.title.like'),
            text: this.$t(error),
            color: 'primary',
            id: this.page.id
          }, {
            component: "CommentsPost",
            action: "likeNode",
            params: {
              page: this.page, 
              nodeId: node.id
            }
          })
        }

        if(postNode){
          //this.$emit('getPosts')
          this.$emit('addPostLike', node.id)
        }
        else
          this.getComments()
      })
    },
  },

  computed: {
   getCountComments(){
     if(this.page.network == 'facebook'){
     let count = 0
     this.comments.data.forEach(c => count += c.comment_count)
     return this.post && this.post.comments && this.post.comments.summary && this.post.comments.summary.total_count
              ? this.post.comments.summary.total_count + count
              : 0
     }
     if(this.page.network == 'instagram'){
       return this.post.comment_count
     }
     if(this.page.network == 'linkedin'){
       return this.post.comment_count
     }
     
   },

   getCountLikes(){
     if(this.page.network == 'facebook'){
     return this.post && this.post.likes && this.post.likes.summary && this.post.likes.summary.total_count
              ? this.post.likes.summary.total_count
              : 0
     }
     if(this.page.network == 'instagram' || 'linkedin'){
       return this.post.like_count
     }

   },

   getCountShares(){
     return this.post && this.post.shares && this.post.shares.count
              ? this.post.shares.count
              : 0
   },

   has_liked(){
     return this.post.likes && this.post.likes.summary && this.post.likes.summary.has_liked 
              ? this.post.likes.summary.has_liked
              : false
   }
  },

  watch: {
   
  }
}    
</script>